import { render, staticRenderFns } from "./ReservationConfirm.vue?vue&type=template&id=145a9424&scoped=true"
import script from "./ReservationConfirm.vue?vue&type=script&lang=ts"
export * from "./ReservationConfirm.vue?vue&type=script&lang=ts"
import style0 from "./ReservationConfirm.vue?vue&type=style&index=0&id=145a9424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a9424",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSnackbar})
